import React from 'react';
import { FormattedMessage } from 'react-intl';

import Spinner from 'components/Shared/Spinner/Spinner';
import { getTxnTextBasedOnType } from 'shared/utils';
import { colors, fontSize } from 'styles/cp';

interface EstimateMessageProps {
  pdfUrl?: string;
  isPDFError: boolean;
  isChangeOrder?: boolean;
}

const EstimateMessage: React.FC<EstimateMessageProps> = ({ pdfUrl, isPDFError, isChangeOrder }) => {
  const { transaction_text, Transaction_text } = getTxnTextBasedOnType(isChangeOrder);
  const transaction = (
    <FormattedMessage
      id={transaction_text}
      defaultMessage={transaction_text}
      values={{ transaction: transaction_text }}
    />
  );
  const Transaction = (
    <FormattedMessage
      id={Transaction_text}
      defaultMessage={Transaction_text}
      values={{ transaction: Transaction_text }}
    />
  );
  if (pdfUrl) {
    return (
      <a href={pdfUrl} rel="noopener nofollow" data-testid="view-estimate-link">
        <FormattedMessage
          id="VIEW_ESTIMATE"
          defaultMessage="View {transaction}"
          values={{ transaction }}
        />

        <style jsx>{`
          a {
            color: ${colors.intuit_blue};
            font-size: ${fontSize.xs};
            text-decoration: none;
          }
        `}</style>
      </a>
    );
  }

  if (isPDFError) {
    return (
      <div>
        <FormattedMessage
          id="ESTIMATE_UNAVAILABLE"
          defaultMessage="{Transaction} unavailable"
          values={{ Transaction }}
        />

        <style jsx>{`
          div {
            color: ${colors.whiteGray};
            font-size: ${fontSize.xs};
          }
        `}</style>
      </div>
    );
  }

  return (
    <div>
      <Spinner
        color={colors.whiteGray}
        label={''}
        bgStrokeWidth={2.5}
        width={10}
        strokeWidth={5}
        bgColor={colors.gray08}
      />
      <FormattedMessage
        id="LOADING_ESTIMATE"
        defaultMessage="Loading {transaction}"
        values={{ transaction }}
      />

      <style jsx>{`
        div {
          color: ${colors.whiteGray};
          font-size: ${fontSize.xs};
        }
      `}</style>
    </div>
  );
};

export default EstimateMessage;
